import { render } from "./DVRVideoListItem.vue?vue&type=template&id=18a1af02&scoped=true"
import script from "./DVRVideoListItem.vue?vue&type=script&lang=js"
export * from "./DVRVideoListItem.vue?vue&type=script&lang=js"

import "./DVRVideoListItem.vue?vue&type=style&index=0&id=18a1af02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18a1af02"]])

export default __exports__